(() => {
  const HOST_SELECTOR = '#ShopifyChat, inbox-online-store-chat';
  const TRIGGER_SELECTOR = '[data-mari-open-inbox], a[href="#send-message"], a[href="#message-us"], button[href="#send-message"], button[href="#message-us"]';
  const SHADOW_STYLE_ID = 'mari-inbox-gate-style';
  const PAGE_STYLE_ID = 'mari-inbox-member-page-hide-style';
  const IS_MEMBER_PAGE = /\/a\/members(?:\/|$)/.test(window.location.pathname);
  const IS_SPANISH = document.documentElement.lang && document.documentElement.lang.toLowerCase().startsWith('es');
  const SPANISH_TEXT_MAP = new Map([
    ['Please choose one of the topics below. Mari’s team will review your message and reach out to you by email.', 'Elige uno de los temas abajo. El equipo de Mari revisará tu mensaje y te responderá por email.'],
    ['Instant answers', 'Respuestas instantáneas'],
    ['Start a consultation', 'Iniciar una consulta'],
    ['Online Course', 'Curso en línea'],
  ]);

  const localizeSpanishInboxText = (root) => {
    if (!IS_SPANISH || !root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const replacement = SPANISH_TEXT_MAP.get(node.textContent.trim());
      if (replacement) node.textContent = replacement;
    });
  };

  const injectShadowStyle = (host) => {
    if (!host || !host.shadowRoot || host.shadowRoot.getElementById(SHADOW_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = SHADOW_STYLE_ID;
    style.textContent = `
      .chat-app--close-button-bottom-right[aria-expanded="false"],
      .chat-toggle[aria-expanded="false"] {
        display: none !important;
        opacity: 0 !important;
        pointer-events: none !important;
        visibility: hidden !important;
      }

      .customer-info-form__checkbox-wrapper {
        display: none !important;
      }

    `;
    host.shadowRoot.appendChild(style);
  };

  const watchShadowText = (host) => {
    if (!IS_SPANISH || !host || !host.shadowRoot || host.dataset.mariInboxTextWatcher === 'true') return;

    host.dataset.mariInboxTextWatcher = 'true';
    localizeSpanishInboxText(host.shadowRoot);

    const observer = new MutationObserver(() => {
      localizeSpanishInboxText(host.shadowRoot);
    });

    observer.observe(host.shadowRoot, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  const injectPageStyle = () => {
    if (!IS_MEMBER_PAGE || document.getElementById(PAGE_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = PAGE_STYLE_ID;
    style.textContent = `
      #ShopifyChat,
      inbox-online-store-chat {
        display: none !important;
        opacity: 0 !important;
        pointer-events: none !important;
        visibility: hidden !important;
      }
    `;
    document.head.appendChild(style);
  };

  const getHost = () => document.querySelector(HOST_SELECTOR);

  const prepareInbox = () => {
    injectPageStyle();

    if (IS_MEMBER_PAGE) return true;

    const host = getHost();
    if (!host || !host.shadowRoot) return false;
    injectShadowStyle(host);
    watchShadowText(host);
    localizeSpanishInboxText(host.shadowRoot);
    return true;
  };

  const openInbox = (attempt = 0) => {
    const host = getHost();
    if (!host || !host.shadowRoot) {
      if (attempt < 40) window.setTimeout(() => openInbox(attempt + 1), 150);
      return false;
    }

    injectShadowStyle(host);
    watchShadowText(host);
    localizeSpanishInboxText(host.shadowRoot);

    const toggle = host.shadowRoot.querySelector('.chat-app--close-button-bottom-right, .chat-toggle');
    if (!toggle) {
      if (attempt < 40) window.setTimeout(() => openInbox(attempt + 1), 150);
      return false;
    }

    if (toggle.getAttribute('aria-expanded') !== 'true') {
      toggle.click();
    }

    return true;
  };

  const bindTriggers = () => {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(TRIGGER_SELECTOR);
      if (!trigger) return;

      event.preventDefault();
      openInbox();
    });
  };

  const watchForInbox = () => {
    prepareInbox();

    const observer = new MutationObserver(() => {
      prepareInbox();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  };

  window.MariOpenInbox = openInbox;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      bindTriggers();
      watchForInbox();
    });
  } else {
    bindTriggers();
    watchForInbox();
  }
})();
